export const defaultEmptyString = '--';

export const handleEmpty = (value: any | undefined | null, emptyString?: string) =>
  value || (emptyString ?? defaultEmptyString);
